import { ETSY_URL, trackEtsy } from "../data/site";
import { ArrowUpRight } from "lucide-react";

export default function BrandStory() {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative py-28 md:py-40 px-6 md:px-12 lg:px-20 bg-[#0B0B0B]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4 reveal">
          <span className="text-[11px] tracking-[0.42em] uppercase text-[#D4AF37]">
            № 02 — The Story
          </span>
          <div className="mt-6 gold-divider w-24" />
          <p className="mt-8 text-sm tracking-[0.18em] uppercase text-white/55 leading-loose">
            Curated in Melbourne. <br />
            Sourced from East Africa.
          </p>
        </div>

        <div className="lg:col-span-8 reveal">
          <h2 className="font-serif-display text-[36px] sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-white">
            Where culture <br />
            meets <span className="italic text-gold-shimmer">craftsmanship.</span>
          </h2>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-3xl">
            <p className="text-[15px] leading-[1.85] text-white/75 font-light">
              Kendi Collections is a love letter to the artisans of the African
              continent — to the women who weave, the elders who carve, the
              mothers who string each bead. Every piece in our shop is made by
              hand, in small workshops, across generations of skill.
            </p>
            <p className="text-[15px] leading-[1.85] text-white/75 font-light">
              From our home in Melbourne, we bring these heirlooms to a global
              audience — preserving stories, paying fair, and refusing the
              factory line. What you take home is more than a product. It is a
              piece of place, of person, of patience.
            </p>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-4">
            <a
              href={ETSY_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEtsy("story_etsy_link")}
              data-testid="story-etsy-link"
              className="gold-link"
            >
              Meet the makers on Etsy
              <ArrowUpRight className="w-4 h-4" />
            </a>
            <span className="hidden md:inline-block h-4 w-px bg-white/15" />
            <span className="text-[11px] tracking-[0.32em] uppercase text-white/45">
              Est. 2024 · Melbourne, AU
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
